import type {
  RelationTypeDetailRaw,
  RelationTypeDetailUI,
  RelationTypeListRaw,
  RelationTypeRow,
} from "~/features/admin/relationTypes/types";

function toRelationTypeRow(raw: RelationTypeListRaw): RelationTypeRow {
  return {
    id: raw.id,
    name: raw.name,
    sourceCategoryName: raw.sourceCategory.name,
    targetCategoryName: raw.targetCategory.name,
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

export function toRelationTypeRowList(raws: readonly RelationTypeListRaw[]): RelationTypeRow[] {
  return raws.map(toRelationTypeRow);
}

export function toRelationTypeDetailUI(raw: RelationTypeDetailRaw): RelationTypeDetailUI {
  return {
    id: raw.id,
    name: raw.name,
    sourceCategoryId: raw.sourceCategory.id,
    sourceCategoryName: raw.sourceCategory.name,
    targetCategoryId: raw.targetCategory.id,
    targetCategoryName: raw.targetCategory.name,
    createdAt: raw.createdAt,
    updatedAt: raw.updatedAt,
    deactivatedAt: raw.deactivatedAt ?? null,
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}
